<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogToolVerificationImport_title">
        Import Tool Verification
      </div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img alt="close" src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="importForm">
      <!-- Project Type Selection -->
      <!-- <div class="form-group">
        <label class="sub-header-drpdown">Project type *</label>
        <div class="radio-container">
          <div class="setPadding">
            <input
              class="customRadio radioColor"
              id="selectPackaging"
              type="radio"
              name="SelectProject"
              [value]="ProjectType.PACKAGING_PROJECT"
              [checked]="selectedProject === ProjectType.PACKAGING_PROJECT"
              (change)="onChangeRadio($event)"
            />
            <label class="label">Packaging project</label>
          </div>
          <div class="setPadding">
            <input
              class="customRadio radioColor"
              id="selectProduct"
              type="radio"
              name="SelectProject"
              [value]="ProjectType.PRODUCT_PROJECT"
              [checked]="selectedProject === ProjectType.PRODUCT_PROJECT"
              (change)="onChangeRadio($event)"
              disabled
            />
            <label class="labelColor disabled-option">Product project</label>
            <small class="text-muted"> (Coming soon)</small>
          </div>
        </div>
        <div *ngIf="!selectedProject && formSubmitted" class="input-error">
          Project Type is required
        </div>
      </div> -->
      <div class="row">
        <!-- Project Code Input -->
        <div class="form-group col-md-12">
          <label for="projectCode" class="sub-header-drpdown"> Project code * </label>
          <input
            id="projectCode"
            type="text"
            class="form-control"
            formControlName="projectCode"
            placeholder="e.g., P0000000-29/Nov/21"
            (change)="updateProjectCode($event)"
            (focusout)="validateProjectCode()"
            (mouseenter)="validateProjectCode()"
          />
          <div
            *ngIf="
              importForm.controls['projectCode']?.touched &&
              importForm.controls['projectCode']?.invalid
            "
            class="input-error"
          >
            <span *ngIf="importForm.controls['projectCode']?.errors?.['required']">
              Project code is required
            </span>
            <span *ngIf="importForm.controls['projectCode']?.errors?.['invalidProjectCode']">
              This project code is invalid or doesn't exist in our system
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- Excel File Upload -->
        <div class="form-group col-md-12">
          <label for="excelFile" class="sub-header-drpdown">Import excel file *</label>
          <piqet-angular-file-upload
            [type]="'excel'"
            [customConfig]="excelUploadConfig"
            [isDisabled]="isUploading"
            (fileSelected)="onFileSelected($event)"
            (fileRemoved)="onFileRemoved()"
            [customClass]="'col-sm-12'"
            (removeConfirmation)="onRemoveConfirmation()"
          >
          </piqet-angular-file-upload>
          <div
            *ngIf="
              importForm.controls['excelFile']?.touched && importForm.controls['excelFile']?.invalid
            "
            class="input-error"
          >
            Excel file is required
          </div>
        </div>
      </div>

      <!-- Server Error Alert -->
      <div
        class="alert alert-danger alert-dismissible fade show mt-3"
        role="alert"
        *ngIf="serverErrorMessage"
      >
        <i class="fa fa-exclamation-circle me-2"></i>
        {{ serverErrorMessage }}
      </div>
    </form>
  </div>

  <div class="modal-footer extraPadding">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button
      type="button"
      class="modelBtn purpleBtnHoverEffect"
      [disabled]="
        importForm.invalid || isUploading || serverErrorMessage || isValidatingProjectCode
      "
      (click)="onSave()"
    >
      <span *ngIf="!isUploading">Import</span>
      <span *ngIf="isUploading"> <i class="fa fa-spinner fa-spin mr-1"></i> Importing... </span>
    </button>
  </div>
</div>
